import React from 'react';
import { createRoot } from 'react-dom/client';
// Bundle the maplibre-gl CSS (matching the installed maplibre-gl version)
// instead of render-blocking on an external CDN stylesheet in index.html
import 'maplibre-gl/dist/maplibre-gl.css';
import AppProvider from './AppProvider';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<React.StrictMode>
  <AppProvider />
</React.StrictMode>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
